import { useCallback, useState } from "react";

const useFirstFocus = <P>(fn: (params?: P) => void) => {
    const [focusMap, setFocusMap] = useState<Record<string, boolean>>({});

    const handleFirstFocus = useCallback(
        (key: string, params?: P) => {
            if (!focusMap[key]) {
                setFocusMap((fMap) => ({ ...fMap, [key]: true }));
                fn(params);
            }
        },
        [focusMap, fn],
    );

    return handleFirstFocus;
};

export default useFirstFocus;
